import React, { Fragment } from "react";
import { shallowEqual } from "react-redux";
import * as Styles from "./styles/ResultsAem";
import { useTradeInAemSelector } from "../../../redux/store";
import { useTradeInCsl } from "../../../csl/tradeInCslUtils";
import { useTradeInAemLabel } from "../../../utils/labels";

const TradeInAemVehicleResultBlock = (): JSX.Element => {
    const csl = useTradeInCsl();
    const { description, name } = useTradeInAemSelector(csl.vehicleNameSelector, shallowEqual);
    const vehicleInfo = useTradeInAemSelector(csl.vehicleInfoBlockSelector, shallowEqual);
    const titleLabel = useTradeInAemLabel("tradeInAemVehicleResultBlockTitle");

    return (
        <div>
            <Styles.Title>{titleLabel}</Styles.Title>
            <Styles.Card>
                <Styles.CardHeader>
                    <Styles.CardTitle>{name}</Styles.CardTitle>
                    {description}
                </Styles.CardHeader>
                {vehicleInfo.length > 0 && (
                    <Styles.CardBody>
                        <Styles.List>
                            {vehicleInfo.map((info) => (
                                <Fragment key={info.label}>
                                    <dt>{info.label}</dt>
                                    <dd>{info.value}</dd>
                                </Fragment>
                            ))}
                        </Styles.List>
                    </Styles.CardBody>
                )}
            </Styles.Card>
        </div>
    );
};

export default TradeInAemVehicleResultBlock;
